export default __webpack_public_path__ + "da8049b91e0220fea44eb5f49480f383.png";